import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgMarqueeComponent } from './ng-marquee.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NgMarqueeComponent],
  exports: [NgMarqueeComponent],
})
export class NgMarqueeModule {}
